// extracted by mini-css-extract-plugin
export default {"title":"WithdrawKizChecked_title__snvLO","description":"WithdrawKizChecked_description__UdJ8z"};